import { NavigationRouteContext } from '@react-navigation/native';
import { BulkNewContent } from 'app/screens/new/bulk';
import { View } from 'react-native';
import { styles } from '../components';

import type { OfferHubState } from '../hooks';

export function OfferHubPhotoTab({
  tab,
  bulkRoute,
  navigation,
  focused,
}: Pick<OfferHubState, 'tab' | 'bulkRoute' | 'navigation' | 'focused'>) {
  return (
    <View
      style={[styles.flex, tab !== 'photos' && { display: 'none' }]}
      accessibilityElementsHidden={tab !== 'photos'}
      importantForAccessibility={tab !== 'photos' ? 'no-hide-descendants' : 'auto'}
    >
      <NavigationRouteContext.Provider value={bulkRoute}>
        <BulkNewContent navigation={navigation} route={bulkRoute} embedded active={tab === 'photos' && focused} />
      </NavigationRouteContext.Provider>
    </View>
  );
}
